<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-card flat>
        <v-row no-gutters>
          <v-col
            v-for="(item, i) in computedValue.items"
            :key="i"
            class="pa-2"
            cols="12"
          >
            <v-card outlined>
              <v-row no-gutters>
                <v-col class="pa-2 d-flex align-center" cols="12">
                  <div>
                    <label for="type">{{
                      $t("counterService.typeLabel")
                    }}</label>
                    <v-radio-group
                      id="type"
                      v-model="item.type"
                      class="ma-0"
                      mandatory
                      row
                    >
                      <v-radio
                        :label="$t('counterService.number')"
                        value="number"
                      />
                      <v-radio
                        :label="$t('counterService.percent')"
                        value="percent"
                      />
                    </v-radio-group>
                  </div>

                  <v-spacer />

                  <div>
                    <v-btn :disabled="i === 0" icon @click="moveUp(i)">
                      <v-icon>mdi-chevron-up</v-icon>
                    </v-btn>
                    <v-btn icon @click="removeItem(i)">
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                    <v-btn
                      :disabled="i === computedValue.items.length - 1"
                      icon
                      @click="moveDown(i)"
                    >
                      <v-icon>mdi-chevron-down</v-icon>
                    </v-btn>
                  </div>
                </v-col>

                <v-col class="pa-2" cols="12" md="6">
                  <div class="rowinfo">
                    <icon-picker v-model="item.icon" class="contentinfo" />
                    <help-info
                      :element-name="`${serviceName}-${componentName}-item-icon`"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                      :label="$t('counterService.iconLabel')"
                    />
                  </div>
                </v-col>

                <v-col class="pa-2" cols="12" md="6">
                  <div class="rowinfo">
                    <v-text-field
                      v-model="item.counter"
                      clear-icon="mdi-close-circle-outline"
                      class="contentinfo"
                      clearable
                      dense
                      :label="$t('counterService.counterLabel')"
                      outlined
                    />
                    <help-info
                      v-if="i === 0"
                      :element-name="`${serviceName}-${componentName}-item-counter`"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                      :label="$t('counterService.counterLabel')"
                    />
                  </div>
                </v-col>

                <v-col class="pa-2" cols="12" md="6">
                  <div class="rowinfo">
                    <v-text-field
                      v-model="item.link"
                      clear-icon="mdi-close-circle-outline"
                      clearable
                      class="contentinfo"
                      dense
                      :label="$t('counterService.linkLabel')"
                      outlined
                    />
                    <help-info
                      v-if="i === 0"
                      :element-name="`${serviceName}-${componentName}-item-link`"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                      :label="$t('counterService.linkLabel')"
                    />
                  </div>
                </v-col>

                <v-col class="pa-2" cols="12" md="6">
                  <div class="rowinfo">
                    <v-text-field
                      v-model="item.name"
                      clear-icon="mdi-close-circle-outline"
                      clearable
                      class="contentinfo"
                      dense
                      hide-details
                      :label="$t('counterService.nameLabel')"
                      outlined
                    />
                    <help-info
                      v-if="i === 0"
                      :element-name="`${serviceName}-${componentName}-item-name`"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                      :label="$t('counterService.nameLabel')"
                    />
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>

          <v-col
            v-show="value && value.items && value.items.length > 0"
            cols="12"
          >
            <v-divider />
          </v-col>
        </v-row>
        <div class="rowinfo" style="width: 100%">
          <v-btn
            color="success"
            outlined
            @click="addServiceCounter"
            class="contentinfo"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
          <help-info
            :element-name="`${serviceName}-${componentName}-addServiceCounter`"
            :service-name="serviceName"
            :help-data="helpData"
            class="buttoninfo"
            :label="$t('counterService.addButton')"
          />
        </div>
      </v-card>
    </template>
  </help-info-wrapper>
</template>

<script>
import IconPicker from "../IconPicker";

export default {
  name: "CounterService",

  components: {
    IconPicker,
  },

  props: {
    value: Object,
  },

  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "counter-service",
      type: "number",
    };
  },

  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    addServiceCounter() {
      this.computedValue.items.push({
        type: "number",
        counter: Math.floor(Math.random() * 1000) + 100,
        name: "-",
        icon: "mdi-debian",
        link: "",
      });
      this.$toast.success(this.$t("counterService.successful.added"));
    },
    removeItem(i) {
      this.computedValue.items.splice(i, 1);
      this.$toast.success(this.$t("counterService.successful.removed"));
    },
    moveUp(index) {
      let items = this.computedValue.items;
      this.computedValue.items = [];

      this.$nextTick(() => {
        let previousIndex = index - 1;
        let tempPreviousImage = { ...items[previousIndex] };
        let tempCurrentImage = { ...items[index] };

        items[index] = tempPreviousImage;
        items[previousIndex] = tempCurrentImage;

        this.$forceUpdate();
        this.computedValue.items = items;
        this.$toast.success(this.$t("counterService.successful.movedUp"));
      });
    },
    moveDown(index) {
      let items = this.computedValue.items;
      this.computedValue.items = [];

      this.$nextTick(() => {
        let nextIndex = index + 1;
        let tempPreviousImage = { ...items[nextIndex] };
        let tempCurrentImage = { ...items[index] };

        items[index] = tempPreviousImage;
        items[nextIndex] = tempCurrentImage;

        this.$forceUpdate();
        this.computedValue.items = items;
        this.$toast.success(this.$t("counterService.successful.movedDown"));
      });
    },
  },
};
</script>

<style scoped></style>
